import { createContext } from "react";
import { ChangeVuln } from "../sdkStructs";

export interface EditorContextProps {
  saveVulnChanges: (data: ChangeVuln) => void,

  value: string,
  setValue: (newValue: string) => void,
}

export const EditorContext = createContext<EditorContextProps>({
  saveVulnChanges: () => {},

  value: "",
  setValue: () => {},
});
